<template>
    <span v-html="value">{{value}}</span>
</template>

<script>


    export default {
        name: 'TheTextView',
        components: {

        },
        data() {
            return {

            }
        },
        props: {
            value: String
        }
    }
</script>